import SaascadaVue from './SaascadaVue';
import FieldValidationCodes from '@/lib/FieldValidationCodes';

export default class SaascadaVueFieldGroup extends SaascadaVue {
    public FieldValidationCodes = FieldValidationCodes;
}